import { Event } from '../../graphql/types.gen'

export function createEditEventPath(slug: Event['slug']) {
  return `/event/${slug}/edit`
}
